'use client'

import { uselang } from "@/context/LangContext";
import css from "./locale_select.module.scss"
import clsx from "clsx"

import React, { useContext, useEffect, useRef } from "react";
import { langDefaultList, langTypes } from "@/type/lang";
import { DeviceContext } from "@/context/deviceContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

type modeTypes = "wide" | "icon"
export default function LocaleSelect({ mode = "wide" }: { mode?: modeTypes }) {
    const { mobileMode } = useContext(DeviceContext)
    const { lang, langList } = uselang();

    const langRef = React.useRef<HTMLDivElement>(null)

    // 언어 선택창 열기 닫기
    const [expended, setExpended] = React.useState<boolean>(false);

    // 선택한 언어
    const selectLang: langTypes = React.useMemo(() => {
        if(!langList || !langList.length) return langDefaultList[0];
        
        return langList.find((el) => el.code == lang) || langDefaultList[0]
    }, [lang, langList])

    React.useEffect(() => {
        function handleClickOutside(e: MouseEvent) {
            if (langRef.current && !langRef.current.contains(e.target as Node)) {
                // 바깥 영역 클릭 닫기.
                setExpended(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [])

    React.useEffect(() => {
        // 변경 되면 닫기
        setExpended(false)
    }, [lang])

    return (
        <div className={clsx(
                mode == "wide" && css.PC,
                mode == "icon" && css.MO
            )}>
            <div className={css.LocaleContainer} ref={langRef}>
                <div className={`${css.selectedBox} ${css.BoxSize} cursor-pointer`} onClick={e => setExpended(!expended)}>
                    <LangBox langData={selectLang} mode={mode} />
                    <div className={css.expendedDown}>
                        <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                </div>
                <div className={clsx(css.floatContainer, css.BoxSize, expended && css.expended)}>
                    <div className={css.floatInner}>
                        {
                            langList.map((l, i) => (
                                <LangBox key={i} langData={l} mode={mode} dispatch />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function LangBox({ langData, dispatch, mode }: { langData: langTypes, dispatch?: boolean, mode: modeTypes }) {
    const { Setlang } = uselang();

    function updateLocale() {
        if (dispatch) {
            Setlang(langData.code)
        }
    }

    const displayRef = useRef<HTMLDivElement>(null)
    useEffect(()=> {
        const ref = displayRef.current
        if(ref){
            // 언어코드 수정
            // if(["en", "ms", 'id'].includes(langData.code)){
            //     if(langData.display.length > 10) {
            //         ref.style.fontSize = "12px"
            //         ref.style.lineHeight = "1"
            //     }else{
            //         ref.style.fontSize = "14px"
            //     }
            // }
            if(langData.display.length > 10) {
                ref.style.fontSize = "12px"
                ref.style.lineHeight = "1"
            }else{
                ref.style.fontSize = "14px"
            }
        }
    }, [langData])
    return (
        <div className={clsx(css.Box, dispatch && "cursor-pointer", mode == "icon" && css.MO)} onClick={updateLocale}>
            <div>
                <span className={`${css.flag} ${css[langData.code]}`}></span>
            </div>
            <div ref={displayRef}>{langData.display}</div>
        </div>
    )
}